import { baseApi } from './baseApi';

export const TAG_PREVENTION_SHIELD = 'PreventionShield';

/** Backend: `language` / `lang` — `en` lub `pl` (np. `pl-PL`, `PL`, `pl_PL` → pierwszy subtag `pl`). */
export function normalizePreventionShieldApiLanguage(lang) {
  if (!lang || typeof lang !== 'string') return 'en';
  const primary = lang.toLowerCase().split(/[-_]/)[0];
  return primary === 'pl' ? 'pl' : 'en';
}

const preventionShieldApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPreventionShield: builder.query({
      query: (language = 'en') => {
        const params = new URLSearchParams({ language });
        return {
          url: `/medapp/prevention-shield/?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => response?.prevention_shield ?? null,
      providesTags: (result, error, language) => [
        { type: TAG_PREVENTION_SHIELD, id: language ?? 'en' },
      ],
    }),
  }),
});

export const { useFetchPreventionShieldQuery, useLazyFetchPreventionShieldQuery } =
  preventionShieldApi;
